import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import EstablishmentLocked from "./EstablishmentLocked";

export default function ProtectedRoute({
    children,
    requireRole = null, // "formateur" | "alternant" | null
    requirePlatformSubscription = false,
}) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="label-eyebrow">Chargement…</div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;

    const isAccountPath = ["/account", "/compte"].includes(location.pathname);
    if (user.role !== "admin" && user.establishment_status && user.establishment_status !== "active" && !isAccountPath) {
        return <EstablishmentLocked user={user} />;
    }

    // Treat admin and responsable as formateur for routing purposes
    const effectiveRole = (user.role === "admin" || user.role === "responsable") ? "formateur" : user.role;

    if (requireRole && effectiveRole !== requireRole) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requirePlatformSubscription && user.role !== "admin" && !user.platform_subscription_active) {
        return <Navigate to="/locked" replace />;
    }

    return children;
}
